import { Route, Routes } from 'react-router';
import { useSelector } from 'react-redux';
import Home from '../pages/Home/Home';
import MapSandbox from '../pages/MapSandbox';
import Order from '../pages/Order';
import OrderSummary from '../pages/OrderSummary';
import Quotes from '../pages/Quotes';
import DevRoutes from '../components/DevRoutes';
import Playground from '../pages/Playground';
import ShopFinder from '../pages/ShopFinder';
import Basket from '../pages/Basket';
import Track from '../pages/Track';
import { InitialSection, TrackSection } from '../pages/Track/components';
import { useAuth } from '../features/Auth';

import {
  BASKET,
  DEV,
  DEV_PLAYGROUND,
  DONT_HAVE_ACCESS,
  EXPIRED_LABEL,
  FAQ,
  HELP,
  HOME,
  MAP_SAND_BOX,
  ORDER,
  ORDER_SUMMARY,
  PRODUCTS_AND_SERVICES,
  QUOTES,
  SHIPMENT,
  SHIPPING_TO_USA,
  SEND_A_CITYSPRINT_PARCEL,
  SEND_A_CITYSPRINT_PARCEL_COMPLETE_BOOKING,
  SEND_A_CITYSPRINT_PARCEL_REVIEW_BOOK,
  SEND_A_CITYSPRINT_PARCEL_SUMMARY,
  CITYSPRINT_BOOKING_CONFIRMATION,
  TRACK,
  TRACK_PARCEL_DETAILS,
  PICKUP_FINDER,
} from '../constants/routes';
import Shipment from '../pages/Shipment';

import {
  Error,
  ERROR_BOUNDARY_TYPES,
  useErrorBoundaryConfigurations,
} from '../features/ErrorBoundary';
import Help from '../pages/Help';
import Faqs from '../pages/Faqs';
import LabelExpiredError from '../pages/ErrorPages/LabelExpiredError';
import ProductsAndServices from '../pages/ProductAndServices';
import ShippingToUsa from '../pages/ShippingToUsa/ShippingToUsa';
import SendCitysprintParcel from '../pages/SendCitysprintParcel';
import SendCitysprintParcelCompleteBooking from '../pages/SendCitysprintParcel/pages/SendCitysprintParcelCompleteBooking';
import SendCitysprintParcelReviewBook from '../pages/SendCitysprintParcel/pages/SendCitysprintParcelReviewBook';
import SendCitysprintParcelSummary from '../pages/SendCitysprintParcel/pages/SendCitysprintParcelSummary';
import CitysprintBookingSuccess from '../pages/SendCitysprintParcel/pages/CitysprintBookingSuccess';
import configSlice from '../redux/configSlice';

function AppRoutes() {
  const { currentSession } = useAuth();
  const getErrorBoundaryConfig = useErrorBoundaryConfigurations();
  const { sameday } = useSelector(configSlice.selectors.getFeatureConfig);

  return (
    <Routes>
      <Route path={HOME} element={<Home />} />
      <Route path={PRODUCTS_AND_SERVICES} element={<ProductsAndServices />} />
      <Route path={SHIPPING_TO_USA} element={<ShippingToUsa />} />
      {sameday && (
        <>
          <Route
            path={SEND_A_CITYSPRINT_PARCEL}
            element={<SendCitysprintParcel />}
          />
          <Route
            path={SEND_A_CITYSPRINT_PARCEL_SUMMARY}
            element={<SendCitysprintParcelSummary />}
          />
          <Route
            path={SEND_A_CITYSPRINT_PARCEL_COMPLETE_BOOKING}
            element={<SendCitysprintParcelCompleteBooking />}
          />
          <Route
            path={SEND_A_CITYSPRINT_PARCEL_REVIEW_BOOK}
            element={<SendCitysprintParcelReviewBook />}
          />
          <Route
            path={CITYSPRINT_BOOKING_CONFIRMATION}
            element={<CitysprintBookingSuccess />}
          />
        </>
      )}
      <Route path={TRACK} element={<Track />}>
        <Route index element={<InitialSection />} />
        <Route path={TRACK_PARCEL_DETAILS} element={<TrackSection />} />
      </Route>
      <Route path={BASKET} element={<Basket />} />
      <Route path={ORDER_SUMMARY} element={<OrderSummary />} />
      <Route path={SHIPMENT} element={<Shipment />} />
      <Route path={MAP_SAND_BOX} element={<MapSandbox />} />
      <Route path={ORDER} element={<Order />} />
      <Route path={QUOTES} element={<Quotes />} />
      <Route path={PICKUP_FINDER} element={<ShopFinder />} />
      <Route path={HELP} element={<Help />} />
      <Route path={FAQ} element={<Faqs />} />
      <Route path={DEV} element={<DevRoutes />}>
        <Route path={DEV_PLAYGROUND} element={<Playground />} />
      </Route>
      <Route
        path={DONT_HAVE_ACCESS}
        element={
          <Error
            config={getErrorBoundaryConfig[
              !currentSession?.uid
                ? ERROR_BOUNDARY_TYPES.DONT_HAVE_ACCESS
                : ERROR_BOUNDARY_TYPES.DONT_HAVE_ACCESS_LOGGED
            ]()}
          />
        }
      />
      <Route path={EXPIRED_LABEL} element={<LabelExpiredError />} />
      <Route path='*' element={<Error />} />
    </Routes>
  );
}

export default AppRoutes;
